import {
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_SUCCESS,
} from '../actionTypes';
import { contactActions } from '../reducer';

import fetchUsers from './fetchUsers';
import filterContacts from './filterContacts';

export default (filterData) => (dispatch) => {
    dispatch(contactActions[INITIALIZE]());
    Promise.all([dispatch(fetchUsers()), dispatch(filterContacts(filterData))])
        .then(() => dispatch(contactActions[INITIALIZE_SUCCESS]()))
        .catch(() => dispatch(contactActions[INITIALIZE_FAILURE]()));
};
